//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as memoAction from '../action/memoAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
//Part
import PartPageTitle from './PartPageTitle';
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
import PartPagingNextPrev from './PartPagingNextPrev';
//Dialog
import DialogMemoCondition from './DialogMemoCondition';
//Func
import atom2datetime from '../func/atom2datetime';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import CreateIcon from '@material-ui/icons/Create';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
import FilterListIcon from '@material-ui/icons/FilterList';

class Comp extends React.Component {

  constructor(props) {
    super(props);
  	this.state = {
      memoDelPic: null,
      dialogMemoConditionOpen: false,
  	}
  }

  componentDidMount() {
    document.title = 'メモ帳 - パートナーズ';
    this.props.memoListGet('', 1);
    window.scrollTo(0, 0);
  }

  _onPaging(page) {
    this.props.memoListGet(this.props.memo.text, page);
    window.scrollTo(0, 0);
  }

	_renderList = (item, index, arr) => {
		return (
      <div
        key={index}
        style={{
          padding:'5px',
          borderBottom: (arr.length - 1 > index) ? 'solid 1px #DDD': ''
        }}
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
          }}
        >
          <div
            onClick={ () => this.props.history.push({pathname: '/partner/' + item.userdata_id_code}) }
            style={{padding:'5px',cursor:'pointer'}}
          >

            <PartUserMainImg
              mainImg={item.userdata_mainImg}
              maxWidth={'160px'}
              width={'40px'}
              height={'auto'}
              radius={'50%'}
            />

          </div>
          <div
            style={{padding:'5px'}}
          >
            <span
              style={{cursor:'pointer'}}
              onClick={ () => this.props.history.push({pathname: '/partner/' + item.userdata_id_code}) }
            >
              <PartUserName
                data={{
                  name: item.userdata_name,
                  sex: item.userdata_sex,
                  size: '1.2em',
                }}
              />
              &nbsp;
              <span style={{color:'#333'}}>{item.userdata_age}才 {item.userdata_prof_region}</span>
            </span>

            <div style={{color:'#666'}}>{atom2datetime(item.datetime_atom, 'DT')}</div>
            <div style={{color:'#666'}}>
              {item.comment.substr( 0, 100 )}
            </div>

          </div>

          <div style={{marginLeft: 'auto'}}>
          <IconButton
            onClick={ () => this.props.partnerOperationOpen(item.userdata_id_code, ['memo']) }
          >
            <CreateIcon/>
            </IconButton>

            <br />
            <IconButton
              onClick={ (event) => this.setState({ memoDelPic: item.userdata_id_code, memoDelAnchor:event.currentTarget}) }
            >
              <MoreVertSharpIcon
                style={{fontSize:'1.2em',color:'#999'}}
              />
            </IconButton>
          </div>
  			</div>
      </div>
		);
	};



	render() {
		return (
      <div>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          <PartPageTitle
            title={'メモ'}
            onback={ '/' }
          />

          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
              margin: '10px',
            }}
          >
            <div>
              <IconButton
                onClick={ () => this.setState({dialogMemoConditionOpen: true}) }
              >
                <FilterListIcon />
              </IconButton>
            </div>
            <div>
              <span style={{color:'#666'}}>ページ{this.props.memo.page}</span>

              <IconButton
                onClick={ () => this.props.memoListGet(this.props.memo.text, 1) }
              >
                <RefreshIcon />
              </IconButton>

            </div>
          </div>
          {
            (this.props.memo.datetime) && (
              (this.props.memo.list.length > 0) ? (
                <div>
                  <Box boxShadow={2} style={{background:'#FFF'}}>
                    {
                      this.props.memo.list.map(
                        (value, index, arr) => this._renderList(value, index, arr)
                      )
                    }
                  </Box>
                  <div style={{margin:'15px'}}>
                    <PartPagingNextPrev
                      page={this.props.memo.page}
                      isNext={this.props.memo.isListNext}
                      onClick={ (e) => this._onPaging(e) }
                    />
                  </div>
                </div>
              ): (
                <div>
                  <h2 align='center' style={{padding:'30px 0px'}}>
                    <span className='i-b'>メモはありませんでした</span>
                  </h2>
                </div>
              )
            )
          }
      	</div>

        <div align='center' style={{margin:'15px'}}>
          <Button
            color="primary"
            variant={ "outlined" }
            onClick={ () => this.props.helpOpen('category','memo') }
          >
            「メモ」とは？
          </Button>
        </div>
        <Menu
          anchorEl={this.state.memoDelAnchor}
          keepMounted
          open={(this.state.memoDelPic)? true: false}
          onClick={ () => this.setState({memoDelPic: null}) }
        >
          <MenuItem
            onClick={ () => {
              this.props.memoListEdit(this.state.memoDelPic, '');
              this.setState({memoDelAnchor:null, memoDelPic:null});
            }}
          >
            <div>
              メモ帳を削除する
            </div>
          </MenuItem>
        </Menu>

        <DialogMemoCondition
          open={ this.state.dialogMemoConditionOpen }
          close={ () => this.setState({dialogMemoConditionOpen: false}) }
          submit={ (text) => {
            this.props.memoListGet(text, 1);
            this.setState({dialogMemoConditionOpen: false});
          }}
        />
      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		memo: state.memo,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...memoAction,
    ...partnerOperationAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
